module.exports = __webpack_public_path__ + "img/3.ae23e974.png";